import { render, staticRenderFns } from "./InformationHistory.vue?vue&type=template&id=6a517eae&"
import script from "./InformationHistory.vue?vue&type=script&lang=js&"
export * from "./InformationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports